export default [
  {
    id: 1,
    content: '작업 전로 차단, 잠금장치 및 꼬리표(LOTO) 부착하고 검전기를 이용하여 충전여부를 확인하고 있다.',
    isChecked: ''
  },
  {
    id: 2,
    content: '전기기구 취급작업 시 전기설비로부터 폭 70cm 이상의 작업공간을 확보하고 있다.',
    isChecked: ''
  },
  {
    id: 3,
    content: '감전위험이 있는 전기기계·기구 또는 전로의 설치·해체·정비·점검(설비의 유효성을 장비, 도구를 이용하여 확인하는 점검) 등의 작업을 하는 경우에 유자격자가 작업을 수행하고 있다.',
    isChecked: ''
  },
  {
    id: 4,
    content: '전기기계·기구 및 설비의 전원 접속부인 충전부가 노출되어 있지 않다.',
    isChecked: ''
  },
  {
    id: 5,
    content: '전기기계·기구 및 설비의 금속재, 철재 등의 외함에 접지시설이 되어있다.',
    isChecked: ''
  },
  {
    id: 6,
    content: '휴대형 또는 이동형 전동기계의 전원에 누전차단기가 설치되어 있다.',
    isChecked: ''
  },
  {
    id: 7,
    content: '전기기기 외함에 접지된 접지선이 접지극과 직접 연결되어 있다.(접지 연속성 유무)',
    isChecked: ''
  },
  {
    id: 8,
    content: '누전여부 체크를 위해 주기적으로 절연저항을 측정하고 기록한다.',
    isChecked: ''
  },
  {
    id: 9,
    content: '주기적으로 접지저항을 측정하고, 접지 저항값이 기준에 적합하다.',
    isChecked: ''
  },
  {
    id: 10,
    content: '용접선, 배선, 이동전선 등 절연전선의 피복이 손상되어 있지 않다.',
    isChecked: ''
  },
  {
    id: 11,
    content: '정전작업 중 타 작업자의 개폐기 오조작 방지를 위하여 분전반 또는 개폐기에 잠금장치나 표지판을 설치하였다.',
    isChecked: ''
  },
  {
    id: 12,
    content: '변전실 출입문에 잠금장치를 하고, 관계자외 출입금지 표시를 부착하였다.',
    isChecked: ''
  },
  {
    id: 13,
    content: '변전실 등 특별고압 충전전로에 접근한계거리 표지판이 부착되어 있다.',
    isChecked: ''
  },
  {
    id: 14,
    content: '근접장소에서의 청소 등의 작업 시 접근한계거리를 유지하여 작업하도록 관리한다.',
    isChecked: ''
  },
  {
    id: 15,
    content: '낙뢰위험지역에 낙뢰에 의한 위험방지를 위해 피뢰침을 설치하였다. ',
    isChecked: ''
  },
  {
    id: 16,
    content: '피뢰침의 접지 저항치를 측정하여 적정한 수준을 유지한다.',
    isChecked: ''
  },
  {
    id: 17,
    content: '물 등의 도전성이 높은 액체가 있는 습윤한 장소에서의 이동전선 등은 충분한 절연효과가 있다.',
    isChecked: ''
  },
  {
    id: 18,
    content: '정전기에 의한 화재, 폭발 등의 위험이 발생할 우려가 있는 경우 해당설비에 대하여 확실한 방법으로 접지, 도전성 재료 사용, 제전장치 등 정전기 제거 조치를 하였다.',
    isChecked: ''
  },
  {
    id: 19,
    content: '전기기계·기구 또는 전로의 설치·해체·정비·점검 등의 전기작업(50V초과 또는 전기에너지가 250VA를 넘는 경우)시 작업계획서를 작성하고 그 계획에 따라 작업을 하였다.',
    isChecked: ''
  },
  {
    id: 20,
    content: '충전전로 등의 전기 작업을 할 때에는 절연용 보호구, 절연용 방호구 등을 근로자에게 지급·착용토록 한다.',
    isChecked: ''
  },
];
